/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderCalcTabGetCalcOptionsQueryVariables = {||};
export type PGAModelBuilderCalcTabGetCalcOptionsQueryResponse = {|
  +pgaModelCalcClassifications: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>
|};
export type PGAModelBuilderCalcTabGetCalcOptionsQuery = {|
  variables: PGAModelBuilderCalcTabGetCalcOptionsQueryVariables,
  response: PGAModelBuilderCalcTabGetCalcOptionsQueryResponse,
|};
*/


/*
query PGAModelBuilderCalcTabGetCalcOptionsQuery {
  pgaModelCalcClassifications {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourModelCalcClassificationType",
    "kind": "LinkedField",
    "name": "pgaModelCalcClassifications",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcTabGetCalcOptionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderCalcTabGetCalcOptionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "df98fa2d95e938b8da6f3131265484a7",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcTabGetCalcOptionsQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderCalcTabGetCalcOptionsQuery {\n  pgaModelCalcClassifications {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '747bfc8bf19cc3238a756032a330f157';

module.exports = node;
